import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CDN_URL } from 'settings';

const useStyles = makeStyles({
  container: {
    width: '100%',
    position: 'absolute',
    zIndex: 1,
    backgroundColor: '#FFF',
    color: '#192542',
    maxHeight: 32,
    '& .chk-wrapper': {
      height: 32,
      margin: 'auto',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: 2,
      maxWidth: 1024
    },
    '& .chk-language__logo': {
      display: 'flex',
      alignItems: 'center',
      '& img': {
        height: 16,
        width: 'auto',
        display: 'block'
      }
    },
    '& .chk-language__selectLanguage': {
      alignItems: 'center',
      display: 'flex',
      fontSize: '.625rem',
      '& span': {
        padding: '0 8px 0 0'
      }
    }
  }
});

const TopBar: React.FC = () => {
  const classes = useStyles({});

  return (
    <div className={`${classes.container} theme-language-bar`}>
      <div className="chk-wrapper">
        <div className="chk-language__logo">
          <img src={`${CDN_URL}/sun/assets/img/eduzz-logo-navy.svg`} alt="eduzz" />
        </div>
      </div>
    </div>
  );
};

export default React.memo(TopBar);
